"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupChatSocketAddObservable = void 0;
const mappers_1 = require("../../mappers");
const Observable_1 = require("../../socket/Observable");
const DomainEvents_1 = require("../../utils/DomainEvents");
class GroupChatSocketAddObservable {
    constructor(chatsStorage, httpAdapter, organizationUser, userDirectory) {
        this.chatsStorage = chatsStorage;
        this.httpAdapter = httpAdapter;
        this.organizationUser = organizationUser;
        this.organization = organizationUser.getOrganization();
        this.userDirectory = userDirectory;
    }
    addChatListener(cb, chatType, groupType) {
        return Observable_1.Observable.getInstance().subscribe((0, DomainEvents_1.getNewChatEventKey)(this.organization.organizationId, chatType, groupType), (data) => {
            const chatLog = (0, mappers_1.groupChatMapper)(data, this.userDirectory, this.organizationUser, this.httpAdapter);
            this.addChats(cb, chatLog, groupType);
        });
    }
    addChats(cb, chatLog, groupType) {
        const newChat = Object.assign({}, chatLog);
        this.chatsStorage.upsertChat(groupType, newChat, false, true);
        const chats = this.chatsStorage.getChatListByType(groupType);
        cb(chats);
    }
}
exports.GroupChatSocketAddObservable = GroupChatSocketAddObservable;
